import styles from "./Home.module.css";

import { useContext, useState } from "react";

import { RetailerContext } from "../../../Context/Retailer.Context";

import { motion } from "framer-motion";


import { useScrollFadeIn } from "../../../Hooks/AnimationHook/UseAnimiationHook";


import TheButton from "../../Components/UI/TheButton/TheButton";
import TheIcon from "../../Components/UI/TheIcon/TheIcon";

import { LanguageContext } from "../../../Context/Language.Context";
import PageWrapperTemplate from "../../Components/UI/Templates/PageWrapperTemplate";


import BodyContainer from "../../Components/UI/BodyContainer/BodyContainer";
import { ExternalLinkButton } from "../../../Utils/link-helper";
import { GridSystem } from "../../Components/GridSystem/GridSystem";

import { AnimatedComponent } from "../../../Hooks/use-framer-motion";
import { PageText } from "../../../components/Text/Text";
import { SearchComponent } from "../../../components/Search/SearchComponent/SearchComponent";
import { useLanguageHook, useSearchHook, useRetailerHook } from "../../../Hooks/use-context-hooks";
import ProductsComingSoon from "../../Components/ProductElements/Containers/ProductsComingSoon";
import TooltipStylePlayground from "../../Components/FeatureDefinitionText/TooltipStylePlayground";
import RetailVersePlayground from "./RetailVersePlayground";

const HomePage = () => {

    const { translatedText, language } = useLanguageHook();

    const [isLoading, setIsLoading] = useState(true);
    const { isHomeDepotApp } = useRetailerHook();

    const { setIsHomepageSearchState, setIsMobileSearchState } = useSearchHook();


    // const [cardRef0, cardInView0] = useScrollFadeIn({
    //     threshold: 0.2,
    //     triggerOnce: true,
    // });
    const [cardRef1, cardInView1] = useScrollFadeIn({
        threshold: 0.2,
        triggerOnce: true,
    });

    const [cardRef2, cardInView2] = useScrollFadeIn({
        threshold: 0.2,
        triggerOnce: true,
    });

    const [cardRef3, cardInView3] = useScrollFadeIn({
        threshold: 0.2,
        triggerOnce: true,
    });


    const handleHomepageSearchClick = () => {
        setIsHomepageSearchState(prevState => ({ ...prevState, isHomepageSearch: true }))
    }

    const handleHomepageMobileSearchClick = () => {
        setIsMobileSearchState(prevState => ({ ...prevState, isMobileSearch: true }))
    }


    const stepUpChartLinkMapLG = [

        // COOKING
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Cooking+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Cooking+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.cooking
        },
        // LAUNDRY
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Laundry+Step+Up+Chart.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Laundry+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.laundry
        },
        // DISHWASHER
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Dish+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Dish+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.dishwasher
        },
        // FRIDGE
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Fridge+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Fridge+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.refrigeration
        }
    ]

    const stepUpChartLinkMapHD = [

        // COOKING
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+Cooking+Step+Up+Chart+HD+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+Cooking+Step+Up+Chart+HD+Fr.pdf"
            ,
            text: translatedText.cooking
        },
        // LAUNDRY
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Laundry+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Laundry+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.laundry
        },
        // DISHWASHER
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Dish+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Dish+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.dishwasher
        },
        // FRIDGE
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Fridge+Step+Up+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Fridge+Step+Up+Chart+Fr.pdf"
            ,
            text: translatedText.refrigeration
        }
    ]

    const renderRetailerStepUpChartLinks = isHomeDepotApp && isHomeDepotApp.isHomeDepotActive === true
        ? stepUpChartLinkMapHD
        : stepUpChartLinkMapLG;


    return (
        <>
            <GridSystem containerPaddingTop="2rem" gridType='spread' containerBackgroundColor="var(--color-gray-07)" >
                <div className={styles.heroContainer}>
                    <div className={styles.contentWrapper}>
                        <div className={styles.heroWrapper}>
                            <div className={styles.heroHeader}>
                                <div className={styles.title}>
                                    <AnimatedComponent type="wipeEffect" directionStart='left' delay={0.5}>
                                        <PageText type='heroSubtitle'>{translatedText.expInnovation}</PageText>
                                    </AnimatedComponent>
                                </div>
                                <div className={styles.title}>
                                    <AnimatedComponent type="wipeEffect" directionStart='left' delay={1}>


                                        <PageText type='heroTitle'>{translatedText.lgPg}</PageText>
                                    </AnimatedComponent>
                                </div>
                            </div>
                            <div className={styles.heroSearch}>
                                <div className={styles.desktopHomeSearchWrapper}>
                                    <div onClick={handleHomepageSearchClick} className={styles.desktopHomeSearchInputWrapper}>
                                        <SearchComponent type='homepage' />
                                    </div>
                                </div>
                                <div className={styles.mobileHomeSearchWrapper}>
                                    <div onClick={handleHomepageMobileSearchClick} className={styles.mobileHomeSearchInputWrapper}>
                                        <SearchComponent type='homepage' />
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </GridSystem>


            <GridSystem gridType='spread' containerBackgroundColor="var(--color-gray-07)">
                <div className={styles.content}>
                    <div className={styles.introTextBox}>

                        <p id={styles.darkTitleText} className={styles.sectionTitleText}>{translatedText.welcomePG}</p>
                        <p id={styles.darkSubtitleText} className={styles.subtitleText}>{translatedText.totSales}</p>
                    </div>

                    <section className={styles.featureSection}>
                        <motion.div
                            className={styles.card}
                            ref={cardRef1}
                            animate={{ opacity: cardInView1 ? 1 : 0, y: cardInView1 ? 0 : 50 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className={styles.cardTextBox}>

                                <p className={styles.cardTitleText}>{translatedText.homeAppliances}</p>
                                <p className={styles.bodyText}>{translatedText.brHACard}</p>
                                <div className={styles.optionsBox}>
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Laundry`} linkText={translatedText.laundry} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Refrigeration`} linkText={translatedText.refrigeration} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Cooking`} linkText={translatedText.cooking} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Dishwasher`} linkText={translatedText.dishwasher} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/LG Studio`} linkText="LG Studio" animated="true" />
                                </div>
                            </div>
                            <div className={styles.cardImageBox}>
                                <TheIcon name="shoppingTag" />
                            </div>
                        </motion.div>
                        <motion.div
                            className={styles.card}
                            ref={cardRef2}
                            animate={{ opacity: cardInView2 ? 1 : 0, y: cardInView2 ? 0 : 50 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className={styles.cardTextBox}>
                                <p className={styles.cardTitleText}>{translatedText.stepUpChart}</p>
                                <p className={styles.bodyText}>{translatedText.brSUCard}</p>
                                <div className={styles.optionsBox}>
                                    <ul className={styles.optionsList}>
                                        {
                                            renderRetailerStepUpChartLinks && renderRetailerStepUpChartLinks.map((e, idx) => (
                                                <li key={idx}>
                                                    {/* <ExternalLink  href={e.link}>{e.text} </ExternalLink> */}
                                                    <ExternalLinkButton linkText={e.text} href={e.link} />
                                                </li>

                                            ))
                                        }
                                    </ul>
                                    {/* <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/compare/Laundry`} linkText={translatedText.laundry} animated="true" />
                                <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/compare/Refrigeration`} linkText={translatedText.refrigeration} animated="true" />
                                <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/compare/Cooking`} linkText={translatedText.cooking} animated="true" />
                                <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/compare/Dishwasher`} linkText={translatedText.dishwasher} animated="true" /> */}
                                </div>
                            </div>
                            <div className={styles.cardImageBox}>
                                {/* <Icon name="searchFile" /> */}
                                <TheIcon name="compareBoard" />
                            </div>
                        </motion.div>
                        <motion.div
                            className={styles.card}
                            ref={cardRef3}
                            animate={{ opacity: cardInView3 ? 1 : 0, y: cardInView3 ? 0 : 50 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className={styles.cardTextBox}>
                                <p className={styles.cardTitleText} >{translatedText.resources}</p>
                                <p className={styles.bodyText}>{translatedText.brRECard}</p>
                                <div className={styles.optionsBox}>
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/resources/definitions`} linkText={translatedText.featureDefinitions} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/resources/warranties`} linkText={translatedText.limitedWarranties} animated="true" />
                                    <TheButton link={`${isHomeDepotApp.isHomeDepotPrefix}/resources/transitions`} linkText={translatedText.modelTransitions} animated="true" />
                                </div>
                            </div>
                            <div className={styles.cardImageBox}>
                                {/* <Icon name="list" /> */}
                                <TheIcon name="squareInfo" />
                            </div>
                        </motion.div>
                    </section>
                </div>
            </GridSystem>
            <GridSystem gridType='spread' containerBackgroundColor="var(--color-gray-06)" containerBorderTop="1px solid var(--color-gray-04)" containerBorderBottom="1px solid var(--color-gray-04)">
              
                <ProductsComingSoon
                  
                    // maxProducts={12}
                    showCount={false}
                />
                {/* <TooltipStylePlayground />
                <RetailVersePlayground /> */}
            </GridSystem>

        </>
    )
}

export default HomePage